<template>
  <v-content>
    <v-container>
      <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
      <h3>Change your Email</h3>
      <v-form @keyup.native.enter="emailSubmit">
        <p>Current email: {{email}}</p>
        <v-text-field label="New Email" solo v-model="email_new" :rules="emailRules" required></v-text-field>
        <v-text-field
          label="Current Password"
          solo
          v-model="password_current"
          :append-icon="show0 ? 'visibility' : 'visibility_off'"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          hint="At least 8 characters"
          counter
          @click:append="show0 = !show0"
          required
        ></v-text-field>

        <v-btn color="success" @click="emailSubmit" class="mr-4" type="submit">Update Email</v-btn>
        <v-btn color="gray" class="mr-4" @click="$router.go(-1)">Cancel</v-btn>
      </v-form>
    </v-container>
  </v-content>
</template>
<script>
import firebase from 'firebase'
import {mapActions} from 'vuex'
export default {
  name: "email",
  data() {
    return {
      show0: false,
      show1: false,
      show2: false,
      password_current: "",
      email: null,
      auth: null, 
      email_new: null,
      alertMsg: "",
      alertType: "",
      displayAlert: false,

      rules: {
        required: value => !!value || "Required."
      },
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ]
    };
  },
  created() {
    if (firebase.auth().currentUser) {
      this.email = firebase.auth().currentUser.email;
      this.auth = firebase.auth().currentUser.uid;
    }
  },
  methods: {
    ...mapActions(["updateProfile"]),
    emailSubmit: function(e) {
      e.preventDefault();

      //alert("CHANGING EMAIL");
      let self = this;

      //console.log("EMAIL:", userEmail)
      //console.log("PASSWORD:", self.password_current)
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, self.password_current)
        .then(function(user) {
          firebase
            .auth()
            .currentUser.updateEmail(self.email_new)
            .then(function() {
              //Do something
              console.log("EMAIL UPDATE SUCCESS");

              // SEND EMAIL VERIFICATION
              firebase
                .auth()
                .currentUser.sendEmailVerification()
                .then(function() {
                  console.log("email verification sent to user");
                  console.log("ROUTER INFO:", self.$router);
                  console.log("ROUTE INFO:", self.$route);
                  let updateInfo = {};
                  updateInfo.email = this.email;
                  updateInfo.auth = this.auth;
                  self.updateProfile(formInfo);

                  self.$router.push({
                    name: "Account",
                    query: {
                      msg: "Check your Email to confirm your email change.",
                      msg_show: true,
                      msg_type: "success"
                    }
                  });
                })
                .catch(function(err) {
                  console.log("THERE WAS AN ERROR: ", err);
                  if (err.code === "auth/weak-password") {
                    self.alertMsg =
                      "The password must be 6 characters long or more.";
                  }
                  if (err.code === "auth/wrong-password") {
                    self.alertMsg =
                      "The password is invalid or the user does not have a password.";
                  } else {
                    self.alertMsg =
                      "There was an error resetting your password. Please try again.";
                  }

                  self.displayAlert = true;
                  self.alertType = "error";
                });
            })
            .catch(function(err) {
              //Do something
              console.log("EMAIL UPDATE FAILED", err);
              console.log("THERE WAS AN ERROR: ", err);
              if (err.code === "auth/weak-password") {
                self.alertMsg =
                  "The password must be 6 characters long or more.";
              }
              if (err.code === "auth/wrong-password") {
                self.alertMsg =
                  "The password is invalid or the user does not have a password.";
              } else {
                self.alertMsg =
                  "There was an error resetting your password. Please try again.";
              }

              self.displayAlert = true;
              self.alertType = "error";
            });
        })
        .catch(function(err) {
          //Do something
          console.log("EXISTING LOGIN IS INCORRECT", err);
          console.log("THERE WAS AN ERROR: ", err);
          if (err.code === "auth/weak-password") {
            self.alertMsg = "The password must be 6 characters long or more.";
          }
          if (err.code === "auth/wrong-password") {
            self.alertMsg =
              "The password is invalid or the user does not have a password.";
          } else {
            self.alertMsg =
              "There was an error resetting your password. Please try again.";
          }

          self.displayAlert = true;
          self.alertType = "error";
        });
    }
  }
};
</script>
<style scoped>
</style>